export default __webpack_public_path__ + "static/query-light-922de66dec4cdf8a7d28dba352859592.png";